import { LockOutlined } from "@ant-design/icons"
import { Flex } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { neutral } from "../tokens"
import type { WidgetProps } from "../types"
import { WidgetFrame } from "../WidgetFrame"

export const RestrictedWidget = ({ widget }: WidgetProps) => {
  const { t } = useTranslation()
  const title = widget.config?.title ?? widget.title

  return (
    <WidgetFrame title={title} state="ready" widgetId={widget.id}>
      <Flex
        vertical
        align="center"
        justify="center"
        gap={4}
        data-testid="widget-restricted"
        style={{ padding: 16, textAlign: "center", height: "100%" }}
      >
        <LockOutlined style={{ fontSize: 20, color: neutral.muted }} />
        <span style={{ fontWeight: 600 }}>
          {t("portfolio.tile.restricted.title", "Access restricted")}
        </span>
        <span style={{ color: neutral.muted }}>
          {t(
            "portfolio.tile.restricted.description",
            "You don't have permission to view this data."
          )}
        </span>
      </Flex>
    </WidgetFrame>
  )
}
